
jQuery(document).ready(function($) {
  $('.ginput_recaptcha').each(function(i) {
    var thisID = $(this).attr('id')
    $(this).attr('id', thisID + '_' + i)
  })

  $('.open__contact[data-open]').on('click', function() {
    var development = $(this).data('developmentId')
    var developmentName = $(this).data('developmentName')
    var plot = $(this).data('plot')
    var type = $(this).data('contactType')
    // Get the targetModal
    var targetModal = $('#' + $(this).data('open'))

    // Go through the target modal to apply dynamic form changes
    // Clear the form from last modal open
    targetModal.find('form')[0].reset()

    // Set the development name
    targetModal.find('#contact-development-name').text(developmentName)

    // Populate the hidden input with development ID
    targetModal.find('#field_7_24 input').val(development)

    // Populate the hidden input with plot ID
    targetModal.find('#field_7_26 input').val(plot)

    // Populate the hidden input with contact type
    targetModal
      .find('#field_7_28 select')
      .val(type)
      .change()

    // Set details about property to sell to hidden
    targetModal.find('#field_7_15').css('display', 'none')

    // Add status dropdown event listener
    $('select[name="input_8"]').on('change', function() {
      // Handle the status change
      var newStatus = $(this).val()

      if (newStatus == 'Property to sell') {
        $('#field_7_15').css('display', 'block')
      } else {
        $('#field_7_15').css('display', 'none')
      }
    })
 
    if (type === 'book_viewing') {
      // Show the notice
      targetModal.find('#field_7_34').css('display', 'block')
    } else {
      // Hide the notice
      targetModal.find('#field_7_34').css('display', 'none')
    }
  })

  // MoneyPenny Form
  $('.open__moneypenny[data-open]').on('click', function() {
    var development = $(this).data('developmentId')
    var developmentName = $(this).data('developmentName')
    var plot = $(this).data('plot')
    var type = $(this).data('contactType')
    // Get the targetModal
    var targetModal = $('#' + $(this).data('open'))

    // Go through the target modal to apply dynamic form changes
    // Clear the form from last modal open
    targetModal.find('form')[0].reset()

    // Set the additionalText + development name
    var additionalText = 'MoneyPenny'
    targetModal
      .find('#contact-development-name')
      .text(additionalText + ' - ' + developmentName)

    // Populate the hidden input with development ID
    targetModal.find('#field_21_24 input').val(development)

    // Populate the hidden input with plot ID
    targetModal.find('#field_21_26 input').val(plot)

    // Populate the hidden input with contact type
    targetModal
      .find('#field_21_28 select')
      .val(type)
      .change()

    // Set details about property to sell to hidden
    targetModal.find('#field_21_15').css('display', 'none')

    // Add status dropdown event listener
    $('select[name="input_8"]').on('change', function() {
      // Handle the status change
      var newStatus = $(this).val()

      if (newStatus == 'Property to sell') {
        $('#field_21_15').css('display', 'block')
      } else {
        $('#field_21_15').css('display', 'none')
      }
    })
  })

  if ($('#apply-reveal').length > 0) {
    $('.button__apply-reveal[data-open]').on('click touch', function() {
      var careerName = $(this).data('career-name')
      var careerId = $(this).data('career-id')
      var targetModal = $('#' + $(this).data('open'))
      targetModal.find('form')[0].reset()
      targetModal.find('.val_summary').remove() // the validation summary message
      targetModal.find('input[type=text]').val('') // this appears to be necessary because if a field passes validation and then I reset the form, these fields do not reset for some reason.
      targetModal.find('li.gfield_error div.validation_message').remove() // remove the validation meesages
      targetModal.find('li.gfield_error').removeClass('gfield_error') // remove the validation classes.
      targetModal.find('[id*="_16"]').val(careerName)
      targetModal.find('[id*="_22"]').val(careerId)
    })
  }

  // Hide the chat widget if it's shown and a modal is opened
  $(document).on('open.zf.reveal', function(event, $el) {
    if (typeof LC_API !== 'undefined') {
      if (LC_API.is_loaded()) {
        // New API
        // LC_API.call('hide')

        // Legacy API
        LC_API.hide_chat_window()
      }
    }
  })

  // Reveal the chat widget if it's shown and a modal is closed
  $(document).on('closed.zf.reveal', function(event, $el) {
    if (typeof LC_API !== 'undefined') {
      if (LC_API.is_loaded()) {
        // New API
        // LC_API.call('minimize')

        // Legacy API
        LC_API.minimize_chat_window()
      }
    }
  })
})
